import SvgIcon from "@mui/material/SvgIcon";

const KuikwitLogo = () => {
  return (
    <SvgIcon
      sx={{
        overflow: "visible",
        width: "42px",
        height: "40px",
        // top: 13,
        // left: 10,
        // position: "fixed",
      }}
    >
      <svg
        width="25"
        height="27"
        viewBox="0 0 40 33"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="Group 3386">
          <g id="Group 289746">
            <path
              id="Vector"
              d="M39.4564 0.034361L33.8689 2.39589L23.7983 12.8916L28.9979 15.453L11.6406 28.3353L18.2963 25.5552C19.348 25.1147 20.5674 25.2647 21.468 25.9456L23.6241 27.5731C23.9824 27.8448 24.5148 27.7043 24.6824 27.2951L26.4639 22.825C26.7399 22.1316 27.279 21.5662 27.9758 21.2351L32.758 18.9641C33.2773 18.7173 33.6717 18.2863 33.859 17.7646L39.979 0.4873C40.0677 0.237403 39.8606 0 39.6141 0C39.5615 0 39.5089 0.0093712 39.4564 0.034361Z"
              fill="url(#paint0_linear_1896_16984)"
            />
            <path
              id="Vector_2"
              d="M7.12844 13.7039C6.55655 13.9444 6.11941 14.4067 5.92878 14.9752L0.0192097 32.518C-0.0826794 32.821 0.239422 33.0959 0.545089 32.9679L4.00932 31.5216L14.8589 20.2137L9.65924 17.6523L25.3797 5.98828L7.12844 13.7039Z"
              fill="url(#paint1_linear_1896_16984)"
            />
          </g>
        </g>
        <defs>
          <linearGradient
            id="paint0_linear_1896_16984"
            x1="42.0463"
            y1="2.74887"
            x2="13.626"
            y2="32.6524"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#6BE900" />
            <stop offset="0.2" stopColor="#66E501" />
            <stop offset="0.42" stopColor="#58DC07" />
            <stop offset="0.66" stopColor="#41CE11" />
            <stop offset="0.9" stopColor="#21B91E" />
            <stop offset="1" stopColor="#13B024" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_1896_16984"
            x1="34.2047"
            y1="-4.70421"
            x2="5.78451"
            y2="25.2025"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#6BE900" />
            <stop offset="0.2" stopColor="#66E501" />
            <stop offset="0.42" stopColor="#58DC07" />
            <stop offset="0.66" stopColor="#41CE11" />
            <stop offset="0.9" stopColor="#21B91E" />
            <stop offset="1" stopColor="#13B024" />
          </linearGradient>
        </defs>
      </svg>
    </SvgIcon>
  );
};

export default KuikwitLogo;
